import { createSlice } from '@reduxjs/toolkit';

const filter = createSlice({
    name: 'filter',
    initialState: {
        isMobileFilterOpen: false,
        isDesktopFilterOpen: true,
        query: '',
    },
    reducers: {
        setMobileFilterOpen: (state, action) => {
            state.isMobileFilterOpen = action.payload;
        },
        setDesktopFilterOpen: (state, action) => {
            state.isDesktopFilterOpen = action.payload;
        },
        setFilterQuery: (state, action) => {
            state.query = action.payload;
        }
    },
});
export const { setMobileFilterOpen,setDesktopFilterOpen, setFilterQuery } = filter.actions;
export default filter.reducer;
